import { styled } from '@sds-system/system';
import { getAllStyledProps } from '@sds-system/utils';
import type { StyledBoxProps } from './Box.types';

export const StyledBox = styled('div')<StyledBoxProps>(() => {
  return {};
}, getAllStyledProps);
